import { loginAsEmployerBlacklistedIds } from './constants'

type ImpersonationTarget = {
  approved_at?: string | boolean | null
  migrated_to_cadence?: boolean | null
}

export const NOT_VERIFIED_TIP = 'Employer must be verified before you can login'

/**
 * Whether ACP can impersonate an employer, and why not when it can't.
 *
 * Impersonation is unavailable for internal employers and for employers migrated
 * to Cadence (Ops act as MSP users instead); the backend refuses to mint a token
 * for either, so controls that rely on it are hidden rather than shown broken. An
 * unverified employer is a temporary state, so the control stays visible but
 * cannot be actioned.
 */
export const employerImpersonation = (employerID?: number, employer?: ImpersonationTarget | null) => {
  const isBlacklisted = !!employerID && loginAsEmployerBlacklistedIds.includes(employerID)
  const isMigratedToCadence = !!employer?.migrated_to_cadence
  const isVerified = !!employer?.approved_at

  return {
    isBlacklisted,
    isMigratedToCadence,
    isVerified,
    /** Whether to render the control at all. */
    isAvailable: !!employerID && !isBlacklisted && !isMigratedToCadence,
    /** Whether the control can actually be actioned. */
    isEnabled: !!employerID && !isBlacklisted && !isMigratedToCadence && isVerified,
  }
}
